"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Done_1 = __importDefault(require("@mui/icons-material/Done"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const status_and_notifications_1 = require("../../../hsbc_img/status_and_notifications");
const tsGoThemeVars_1 = require("../../../material-ui-theme/tsGoThemeVars");
const zustandStore_1 = require("../../../zustandStore");
const lexico = new lexico_1.default();
const DialogText = (0, material_1.styled)(material_1.DialogContentText)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    color: theme.palette.grey[900],
    padding: theme.spacing(1),
    textAlign: 'center',
    ...theme.typography.body1,
}));
const ColorButton = (0, material_1.styled)(material_1.Button)(() => {
    return {
        color: 'white',
        backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
            ? tsGoThemeVars_1.goPalette.hsbcColor.primary
            : tsGoThemeVars_1.goPalette.tsGoColor.pink,
        '&:hover': {
            backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? tsGoThemeVars_1.goPalette.hsbcColor.primary_hover
                : tsGoThemeVars_1.goPalette.tsGoColor.pinkDarker,
        },
    };
});
const AlertDialog = () => {
    const dialog = (0, zustandStore_1.useZustand)(state => state.dialog.alert);
    const showAlert = (0, zustandStore_1.useZustand)(state => state.dialog.alert.open);
    const { resetDialog, closeDialog } = (0, zustandStore_1.useZustand)();
    const getTitle = () => {
        switch (dialog.type) {
            case 'warning': {
                return globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusWarningOnLight, { "data-testid": "WarningIcon", style: { width: '35px', height: '35px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, { fontSize: "large", color: "warning" }));
            }
            case 'success': {
                return globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusConfirmationOnLight, { "data-testid": "DoneIcon", style: { width: '35px', height: '35px' } })) : ((0, jsx_runtime_1.jsx)(Done_1.default, { fontSize: "large", color: "success" }));
            }
            case 'error': {
                return globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { "data-testid": "ErrorIcon", style: { width: '35px', height: '35px' } })) : ((0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "large", color: "error" }));
            }
            default: {
                return globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusInformationOnLight, { "data-testid": "InfoIcon", style: { width: '35px', height: '35px' } })) : ((0, jsx_runtime_1.jsx)(Info_1.default, { fontSize: "large", color: "info" }));
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: showAlert, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", onClose: () => resetDialog(), "data-testid": "dialog", children: [(0, jsx_runtime_1.jsxs)(material_1.DialogContent, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { component: "div", sx: {
                            margin: 1,
                            display: 'flex',
                            justifyContent: 'center',
                        }, children: getTitle() }), (0, jsx_runtime_1.jsx)(DialogText, { "data-testid": "alert-dialog-description", id: "alert-dialog-description", children: dialog.message })] }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { sx: { justifyContent: 'center', margin: 1 }, children: [(0, jsx_runtime_1.jsx)(ColorButton, { "data-testid": "alert-dialog-action-button", onClick: () => {
                            closeDialog();
                            if (typeof dialog.onAccept === 'function') {
                                dialog.onAccept();
                            }
                        }, variant: "contained", color: dialog.type || 'info', children: dialog.actionText }), dialog.showCancel ? ((0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "alert-dialog-cancel-button", onClick: () => resetDialog(), variant: "contained", color: "secondary", children: dialog.cancelText || lexico.tr('Cancel') })) : ('')] })] }));
};
exports.default = AlertDialog;
